module.exports = __webpack_public_path__ + "assets/marker-icon-2x.d95d69fa8a7dfe391399e22c0c45e203.png";


//////////////////
// WEBPACK FOOTER
// ../~/leaflet/dist/images/marker-icon-2x.png
// module id = 1151
// module chunks = 0